// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__O44Sx","projectImage":"Projects_projectImage__2NR3Z","projectLogo":"Projects_projectLogo__IOyei"};